import { loc } from 'okta';
export default {
  title () {
    return loc('oie.email.mfa.title', 'login');
  }
};



// WEBPACK FOOTER //
// ./src/v2/view-builder/views/shared/email.js